<template>
  <Attachments
    :label="$lang.attachments"
    uploaderName="help"
    resourceName="help"
    :shouldEditableAttachmentType="false"
    :getListMethod="handleGetAttachments"
    :createMethod="handleCreateAttachment"
    :updateMethod="handleUpdateAttachment"
    :deleteMethod="handleDeleteAttachment"
  />
</template>
<script>
import { Attachments } from "@/components/re-design";
import {
  getAttachments,
  createAttachment,
  updateAttachment,
  deleteAttachment,
} from "@/modules/home/services";
import { generateError, generateCurrentRoute } from "@/shared/utils";
export default {
  components: { Attachments },
  setup() {
    const helpKey = generateCurrentRoute();
    const handleGetAttachments = async (page, perPage) => {
      try {
        const response = await getAttachments(helpKey, page, perPage);
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleCreateAttachment = async (tempFiles) => {
      try {
        const response = await createAttachment(helpKey, tempFiles);
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleUpdateAttachment = async (
      attachmentCode,
      attachmentTypeId,
      attachmentCaption
    ) => {
      try {
        const response = await updateAttachment({
          key: helpKey,
          attachmentCode,
          attachmentCaption,
        });
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleDeleteAttachment = async (attachmentCode) => {
      try {
        const response = await deleteAttachment(helpKey, attachmentCode);
        return response;
      } catch (error) {
        generateError(error);
      }
    };

    // return data to be used in template
    return {
      handleGetAttachments,
      handleCreateAttachment,
      handleUpdateAttachment,
      handleDeleteAttachment,
    };
  },
};
</script>
